import React from 'react';

import Button from '@components/objects/Button/Button';

class DynamicInputs extends React.Component {

    state = { rows: this.props.value ? this.props.value : [] };

    componentDidUpdate = (prevProps) => {
        if(prevProps.value !== this.props.value) {
            this.setState({
                rows: this.props.value
            });
        }
    }

    addRow = () => {
        const rows = {}
        for (let i = 0; i < this.props.inputFields.length; i++) {
            rows[this.props.inputFields[i].className] = '';
        }

        this.setState((prevState) => ({
            rows: [...prevState.rows, rows]
        }));
    };

    addRowInputs = (index) => {

        let inputs = [];
        for (let i = 0; i < this.props.inputFields.length; i++) {

            let inputField;
            const id = this.props.title + this.props.inputFields[i].className + parseInt(index, 10)

            if (this.props.inputFields[i].inputType === 'textarea') {

                inputField = <textarea
                    data-id={index}
                    id={id}
                    onChange={this.props.handlechange}
                    className={this.props.inputFields[i].className}
                    value={this.state.rows[index][this.props.inputFields[i].className]}
                ></textarea>;

            } else if (typeof this.props.inputFields[i].inputType === 'function') {

                const Component = this.props.inputFields[i].inputType;
                inputField = <Component {...this.props.inputFields[i].props} {...this.props.inputFields[i].componentProps} />;

            } else {

                inputField = <input
                    type={this.props.inputFields[i].inputType}
                    data-id={index}
                    id={id}
                    onChange={this.props.handlechange}
                    className={this.props.inputFields[i].className}
                    value={this.state.rows[index][this.props.inputFields[i].className]}
                />;
            }

            inputs.push(<div key={i}>
                <label htmlFor={this.props.inputFields[i].className + parseInt(index, 10)}>{this.props.inputFields[i].label}</label>
                {this.props.inputFields[i].description ? <p>{this.props.inputFields[i].description}</p> : null}
                {inputField}

            </div>);
        }

        return inputs;
    };

    removeRow = (index) => {

        const rows = [...this.state.rows];
        rows.splice(index, 1);
        this.setState({ rows: rows });
    };

    render() {

        let { rows } = this.state;
        const rowsLength = rows.length;

        return (
            <div className={this.props.className}>

                <header>
                    <span>
                        {rowsLength < this.props.maxnumber ? <Button text={this.props.buttonLabel} onClick={this.addRow} /> : null}

                    </span>
                </header>
                <div>
                    {
                        rows.map((val, idx) => {
                            return (
                                <div className={this.props.className + '__item ' + this.props.className + "__item--faq"} key={idx}>
                                    <label>{idx + 1})</label>
                                    <div>
                                        <div>
                                            {this.addRowInputs(idx)}
                                        </div>
                                        {rowsLength === idx + 1 ?
                                            <div className={this.props.className + "__remove"}>
                                                <button type='button' onClick={() => this.removeRow(idx)}>x</button><label>Remove</label>
                                            </div> : null}

                                    </div>

                                </div>
                            )
                        })
                    }
                </div>
                <div className={this.props.className + '__button'}>
                    <span>
                        <Button text={this.props.buttonLabel} onClick={this.addRow} />
                    </span>
                </div>
            </div>
        );
    }
};


export default DynamicInputs;